import React from 'react';
import PropTypes from 'prop-types';
import { FormikProvider } from 'formik';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import NationalIdentifierField from '@fingo/lib/components/fields/NationalIdentifierField';
import PasswordField from '@fingo/lib/components/fields/PasswordField';
import { SECONDARY_OUTLINED_INPUT_CLASS_NAME } from '@fingo/lib/theme/constants/outlined-input';
import useNationalTaxServiceCredentials from '@fingo/lib/hooks/useNationalTaxServiceCredentials';
import UploadFlowDialog from './UploadFlowDialog';

const UploadSiiCredentialsDialog = ({ open, onClose, onBack }) => {
  const { formik, initialNationalIdentifier, t } = useNationalTaxServiceCredentials({
    autocomplete: true,
    onCompleted: onClose,
  });
  const { isValid, isSubmitting, resetForm } = formik;

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleBack = () => {
    resetForm();
    onBack();
  };

  return (
    <UploadFlowDialog
      open={open}
      onClose={handleClose}
      title={(
        <Typography variant="medium_2" fontWeight={700} align="center" sx={{ color: 'gray.A600' }}>
          {`Ingresa las credenciales del ${t('National Tax Service')} de tu empresa`}
        </Typography>
      )}
      actions={(
        <Stack direction="row" spacing={1} justifyContent="center" width="100%">
          <Button variant="outlined" color="primary" onClick={handleBack} size="large_1">
            <Typography variant="small_3" fontWeight={700} sx={{ color: 'primary.main' }}>
              Atrás
            </Typography>
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large_1"
            onClick={formik.handleSubmit}
            disabled={!isValid || isSubmitting}
          >
            <Typography variant="small_3" fontWeight={700} sx={{ color: 'white' }}>
              Confirmar
            </Typography>
          </Button>
        </Stack>
      )}
    >
      <FormikProvider value={formik}>
        <Stack spacing={4} sx={{ width: 408, maxWidth: '100%' }}>
          <NationalIdentifierField
            disabled={Boolean(initialNationalIdentifier)}
            placeholder={`Ingresa el ${t('National identifier')} de la empresa`}
            className={SECONDARY_OUTLINED_INPUT_CLASS_NAME}
          />
          <PasswordField
            variant="outlined"
            label="Contraseña"
            placeholder={`Ingresa tu contraseña ${t('National Tax Service acronym')}`}
            className={SECONDARY_OUTLINED_INPUT_CLASS_NAME}
          />
        </Stack>
      </FormikProvider>
    </UploadFlowDialog>
  );
};

UploadSiiCredentialsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default UploadSiiCredentialsDialog;
